export const MARKETPLACE_PATH = '/';
export const MARKETPLACE_APP_OFFERS_PATH = '/marketplace/apps/:appId/offers';
export const HOME_PATH = MARKETPLACE_PATH;
export const USERS_MANAGEMENT_PATH = '/users-management';
export const SIGN_UP_PATH = '/sign-up';
export const SIGN_IN_PATH = '/sign-in';
export const SEND_CONFIRM_EMAIL_PATH = '/email-confirmation';
export const CONFIRM_EMAIL_PATH = '/verify-email';
export const FORGOT_PASSWORD_PATH = '/forgot-password';
export const RESET_PASSWORD_PATH = '/reset-password';
export const TOS = '/terms-of-service';
export const PRIVACY_POLICY = '/privacy-policy';

export const JOIN_OFFER_PATH = '/join-offer/:id';

export const APPS_PATH = '/apps/:appID';

export const APPS_TASKS_PATH = '/apps/:appID/tasks';
export const APPS_TASKS_CREATE_PATH = '/apps/:appID/tasks/create';
export const APPS_TASKS_VIEW_PATH = '/apps/:appID/tasks/view/:id';
export const APPS_TASKS_VIEW_LOGS_PATH = '/apps/:appID/tasks/view/:id/logs';
export const APPS_TASKS_EDIT_PATH = '/apps/:appID/tasks/edit/:id';

export const APPS_OFFERS_PATH = '/apps/:appID/offers';
export const APPS_OFFERS_VIEW_PATH = '/apps/:appID/offers/view/:id';
export const APPS_OFFERS_CREATE_PATH = '/apps/:appID/offers/create';
export const APPS_OFFERS_EDIT_PATH = '/apps/:appID/offers/edit/:id';

export const APPS_DEALS_PATH = '/apps/:appID/deals';
export const APPS_DEALS_VIEW_PATH = '/apps/:appID/deals/view/:id';
export const APPS_DEALS_VIEW_LOGS_PATH = '/apps/:appID/deals/view/:id/logs';
export const APPS_DEALS_EDIT_PATH = '/apps/:appID/deals/edit/:id';

export const APPS_VIEW_PATH = '/apps/:appID/settings';
export const APPS_EDIT_DETAILS_PATH = '/apps/:appID/settings/edit-details';
export const APPS_EDIT_INTEGRATION_PATH = '/apps/:appID/settings/edit-integration';
export const APPS_EDIT_CATEGORIES_PATH = '/apps/:appID/settings/categories';
export const APPS_EDIT_REWARDS_PATH = '/apps/:appID/settings/rewards';
export const APPS_STATISTICS_PATH = '/apps/:appID/statistics';

export const APPS_CREATE_PATH = '/apps/create';

export const STATISTICS_PATH = '/statistic';

export const PUBLIC_APP_VIEW_PATH = '/catalog/apps/:appId';
